export const pickCountryForCurrency = (list, ccy) => {
    const C = String(ccy || "").toUpperCase();
    const byCurrency = list.find((x) => String(x.currency || "").toUpperCase() === C);
    if (byCurrency) return byCurrency;

    const titleMap = { NGN: "Nigeria", KES: "Kenya", USD: "United State" };
    const wanted = titleMap[C];
    if (!wanted) return null;

    return (
        list.find(({ title }) => {
            const t = String(title || "").toLowerCase();
            if (C === "USD") return t.startsWith("united state");
            return t === wanted.toLowerCase();
        }) || null
    );
};
